module.exports = __webpack_public_path__ + "img/gamma3_ex_p3.ee00b71b.jpg";